import { createAsyncThunk } from "@reduxjs/toolkit";
import { type UpdateAddressParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";
import { getCase } from "./get-case";

/**
 * Corrects one of the customer's addresses and reloads the case (DMS-28), so
 * the address on screen and the trail entry the backend just appended both come
 * from the server rather than from what the form guessed.
 */
export const updateAddress = createAsyncThunk<
  void,
  UpdateAddressParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UPDATE_ADDRESS, async (params, { dispatch, extra }) => {
  await extra.complianceRepo.updateAddress(params);
  await dispatch(getCase({ requestId: params.requestId }));
});
